export default "/images/d57b4e3d962423a9b72b34ae104a8d13.avif";